function getFormattedNumber(number, decimalPlaces = 2) {
  if (number === null || number === undefined || isNaN(number)) {
    return (0).toFixed(decimalPlaces);
  }

  number = +number;
  let numStr = number.toString();
  let result;

  if (numStr.includes('.')) {
    const parts = numStr.split('.');
    let decimalPart = parts[1].substring(0, decimalPlaces);
    result = `${parts[0]}.${decimalPart.padEnd(decimalPlaces, '0')}`;
  } else {
    result = `${numStr}.${'0'.repeat(decimalPlaces)}`;
  }

  // Tách phần nguyên và phần thập phân
  const parts = result.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  // Nếu decimalPlaces = 0 thì chỉ trả phần nguyên đã format
  const rs = decimalPlaces === 0 ? parts[0] : `${parts[0]}.${parts[1]}`;
  return rs;
}

export { getFormattedNumber };
